import React from 'react';
import { Link } from 'react-router-dom';
import StudentVerification from '../components/StudentVerification';
import '../styles/VerificationPage.css'; // We will create this file

const VerificationPage = () => {
    return (
        <div className="verification-page-container">
            <Link to="/" className="back-arrow" title="Go back to the landing page">‹</Link>
            <div className="verification-card">
                <StudentVerification />
            </div>
        </div>
    );
};

export default VerificationPage;
